exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".SearchDialog{overflow-y:scroll}.SearchDialog__content{padding:0 16px;margin:0 auto;box-shadow:rgba(16,32,39,.04) 0px 4px 8px}", ""]);
